import { Box, Chip, Tooltip } from "@material-ui/core";
import { IconWarning } from "icons";
import { LOW_MARGIN_THRESHOLD } from "../PricingByClientConst";
import { ActivityItemPriceModes } from "features/pricingManagement/CreateActivityAndPricing/ActivityItemPricing/PricingCalculator/PricingCalculatorConsts";

const getCellIcon = (pricingData) => {
    if (pricingData.priceMode !== ActivityItemPriceModes.SURCHARGE && pricingData.margin !== null && pricingData.margin < LOW_MARGIN_THRESHOLD) {
        return <IconWarning color="red" size={15} />;
    }

    if (pricingData.priceVariance) {
        return <IconWarning color="orange" size={15} />;
    }

    return null;
};

const PricingLotCell = ({ pricingData, classes, onClick, isBundle = false }) => {
    if (!pricingData) {
        return <div className={classes.emptyCell} onClick={onClick}>-</div>;
    }

    // State 2: pricing combinations exist for this client/lot but no preferred
    // vendor is selected yet. Surface a clear call-to-action instead of a blank cell.
    // Bundles have no preferred-vendor concept, so this state never applies to them.
    if (!isBundle && pricingData.hasPricingCombinations && !pricingData.vendorId && !pricingData.preferredVendorId) {
        return (
            <Tooltip title="Pricing configured — select a preferred vendor" arrow>
                <Box className={classes.needsVendorCell} onClick={() => onClick()}>
                    <span className={classes.needsVendorText}>Set vendor</span>
                </Box>
            </Tooltip>
        );
    }

    return (
        <>
            <Box className={classes.cell} onClick={() => onClick()}>
                {pricingData.isPMFVendor && (
                    <Chip label="PMF" size="small" className={classes.pmfChip} />
                )}
                <span>{pricingData.formattedCharge}</span>
                <span className={classes.cellIcon}>{getCellIcon(pricingData)}</span>
            </Box>
        </>
    );
};

export default PricingLotCell;
